import { useMemo } from 'react'

import { useSelector } from 'react-redux'

import { Breadcrumbs as BreadcrumbsEnum } from 'routes/Checkout/checkoutConfig'
import {
  getDeliveryAddress,
  getEmail,
  getName,
  getPasswordValue,
  getPhone,
} from 'routes/Checkout/checkoutSelectors'

import { accountStepSchema, deliveryStepSchema } from './schemas'

export const useStepValidation = () => {
  const checkoutEmail = useSelector(getEmail)
  const checkoutPassword = useSelector(getPasswordValue)
  const customerName = useSelector(getName)
  const deliveryAddress = useSelector(getDeliveryAddress)
  const phone = useSelector(getPhone)

  const validationState = useMemo(() => {
    const accountData = {
      email: checkoutEmail,
      password: checkoutPassword,
    }

    const deliveryData = {
      firstName: customerName.firstName,
      lastName: customerName.lastName,
      phone,
      houseNo: deliveryAddress?.get('houseNo'),
      street: deliveryAddress?.get('street'),
      town: deliveryAddress?.get('town'),
      postcode: deliveryAddress?.get('postcode'),
    }

    const hasCompletedAccountStep = accountStepSchema.isValidSync(accountData)
    const hasCompletedDeliveryStep = deliveryStepSchema.isValidSync(deliveryData)

    return {
      hasCompletedAccountStep,
      hasCompletedDeliveryStep,
    }
  }, [
    checkoutEmail,
    checkoutPassword,
    customerName.firstName,
    customerName.lastName,
    phone,
    deliveryAddress,
  ])

  const isStepAccessible = useMemo(
    () =>
      (breadcrumb: BreadcrumbsEnum): boolean => {
        if (breadcrumb === BreadcrumbsEnum.ACCOUNT) {
          return true
        }
        if (breadcrumb === BreadcrumbsEnum.DELIVERY) {
          return validationState.hasCompletedAccountStep
        }
        if (breadcrumb === BreadcrumbsEnum.PAYMENT) {
          return validationState.hasCompletedAccountStep && validationState.hasCompletedDeliveryStep
        }

        return false
      },
    [validationState.hasCompletedAccountStep, validationState.hasCompletedDeliveryStep],
  )

  return {
    isStepAccessible,
  }
}
